import { graphql } from 'gatsby';
import React from 'react';
import ArticleNav from '../components/ArticleNav/ArticleNav';
import ArticleSection from '../components/ArticleSection/ArticleSection';
import AuthorCover from '../components/AuthorCover/AuthorCover';
import SEO from '../components/SEO';
import Content from '../components/UI/Content/Content';
import { Grid, GridItem } from '../components/UI/Grid/Grid';
import Section, { themes } from '../components/UI/Section/Section';

const AuthorTemplate = ({
  data: {
    page: { name, description, userAvatar, sectionContent, posts },
  },
}) => {
  return (
    <>
      <SEO title={`Author: ${name}`} description={description}  />
      <ArticleNav />
      <AuthorCover name={name} avatar={userAvatar.avatar} />

      <Section theme={themes.DEFAULT}>
        <Grid justify="center">
          <GridItem md="8" lg="6">
            <Content items={sectionContent.body} />
          </GridItem>
        </Grid>
      </Section>

      <ArticleSection
        heading={`Articles by **${name}**`}
        nodes={posts.nodes}
        cols={{ md: 4, lg: 3 }}
        isChunked
      />
    </>
  );
};

export default AuthorTemplate;

export const query = graphql`
  query AuthorTemplate($id: String!) {
    page: wpUser(id: {eq: $id}) {
      name
      description
      userAvatar {
        avatar {
          localFile {
            childImageSharp {
              gatsbyImageData(
                width: 160
                height: 160
                transformOptions: {grayscale: true}
                layout: FIXED
              )
            }
          }
        }
      }
      sectionContent {
        body {
          ... on WpUser_Sectioncontent_Body_LayoutWysiwyg {
            fieldGroupName
            wysiwyg
          }
          ... on WpUser_Sectioncontent_Body_LayoutImage {
            fieldGroupName
            image {
              title
              ...WpImage
            }
          }
          ... on WpUser_Sectioncontent_Body_LayoutVideo {
            fieldGroupName
            caption
            video
          }
        }
      }
      posts {
        nodes {
          ...Post
        }
      }
    }
  }
`;
